import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import CommonDrawerLayout from '../../../common_components/CommonDrawerLayout';
import { Eye } from 'lucide-react';
import FilePreviewModal from './FilePreviewModal';
const MediaKitDrawer = ({ open, onClose, files }) => {
    const [previewFile, setPreviewFile] = useState(null);
    const handlePreview = (file) => {
        setPreviewFile(file);
    };
    const closePreview = () => {
        setPreviewFile(null);
    };
    return (_jsxs(CommonDrawerLayout, { open: open, onClose: onClose, title: "Media Kit", width: "sm", children: [_jsx(Box, { sx: { p: 1 }, children: files && files.length > 0 ? (files.map((file, idx) => (_jsxs(Box, { sx: {
                        display: 'flex',
                        alignItems: 'center',
                        gap: 2,
                        p: 1,
                        border: '1px solid #EAECF0',
                        borderRadius: '8px',
                        mb: 1,
                        bgcolor: '#fff',
                        transition: 'all 0.2s',
                        '&:hover': {
                            borderColor: '#FF008E',
                            boxShadow: '0px 4px 6px -2px rgba(16, 24, 40, 0.03)'
                        }
                    }, children: [_jsx(Box, { sx: {
                                width: 44,
                                height: 44,
                                bgcolor: '#F2F4F7',
                                borderRadius: '8px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0
                            }, children: _jsx("img", { src: "/assets/pdficon.svg", alt: "PDF", style: { width: 24 } }) }), _jsxs(Box, { sx: { flex: 1, minWidth: 0 }, children: [_jsx(Typography, { sx: {
                                        fontSize: '14px',
                                        fontWeight: 600,
                                        color: '#101828',
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis'
                                    }, children: file.file_name }), _jsxs(Box, { sx: { display: 'flex', gap: 2, mt: 0.5 }, children: [_jsxs(Typography, { sx: { fontSize: '12px', color: '#667085' }, children: ["Date: ", file.uploaded_at ? new Date(file.uploaded_at).toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric' }) : '--'] }), _jsxs(Typography, { sx: { fontSize: '12px', color: '#667085' }, children: ["Size: ", file.size_bytes ? `${(file.size_bytes / (1024 * 1024)).toFixed(1)} MB` : 'Unknown'] })] })] }), _jsx(IconButton, { onClick: () => handlePreview(file), sx: {
                                color: '#667085',
                                '&:hover': { color: '#FF008E', bgcolor: '#FFF1F8' }
                            }, children: _jsx(Eye, { size: 20 }) })] }, idx)))) : (_jsx(Box, { sx: { py: 10, textAlign: 'center' }, children: _jsx(Typography, { sx: { color: '#667085', fontSize: 14 }, children: "No media kit files found." }) })) }), _jsx(FilePreviewModal, { open: !!previewFile, onClose: closePreview, fileUrl: previewFile?.file_url || "", fileName: previewFile?.file_name || "" })] }));
};
export default MediaKitDrawer;
